var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFhir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-1",
    x1: "50.006%",
    x2: "50.006%",
    y1: "119.039%",
    y2: "8.638%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FFF7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#FFF083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#FFE72F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19%",
    stopColor: "#FFE415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#FFE206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28%",
    stopColor: "#FFDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#F2A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    stopColor: "#E86A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DE1119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E20E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-2",
    x1: "49.978%",
    x2: "49.978%",
    y1: "1716.568%",
    y2: "1589.042%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FFF7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#FFF083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#FFE72F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19%",
    stopColor: "#FFE415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#FFE206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28%",
    stopColor: "#FFDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#F2A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    stopColor: "#E86A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DE1119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E20E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-3",
    x1: "49.988%",
    x2: "49.988%",
    y1: "1584.277%",
    y2: "1423.609%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FFF7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#FFF083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#FFE72F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19%",
    stopColor: "#FFE415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#FFE206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28%",
    stopColor: "#FFDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#F2A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    stopColor: "#E86A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DE1119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E20E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-4",
    x1: "49.99%",
    x2: "49.99%",
    y1: "98.848%",
    y2: "-27.528%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    stopColor: "#FFE62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#FFE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81%",
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89%",
    stopColor: "#FFD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92%",
    stopColor: "#FCC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#F7AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98%",
    stopColor: "#F18E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EC7503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-5",
    x1: "50.011%",
    x2: "50.011%",
    y1: "95.015%",
    y2: "-58.071%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FFF8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#FFF183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#FFEC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#FFE82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19%",
    stopColor: "#FFE515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#FFE406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#FFE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28%",
    stopColor: "#FFDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#FDC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#F4A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    stopColor: "#E96A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DE1119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E20E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fhir-6",
    x1: "49.984%",
    x2: "49.984%",
    y1: "95.253%",
    y2: "13.048%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58%",
    stopColor: "#FFE62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69%",
    stopColor: "#FFE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "94%",
    stopColor: "#F7A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F49800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-1)",
    d: "M149.455.356s42.937 67.14 35.47 133.365c-7.467 66.226-53.205 97.009-76.074 147.98-22.868 50.97-9.334 104.134 9.335 117.836C93.45 382.18 28.11 349.753 32.778 263.888c2.333-26.49 19.135-74.446 59.272-120.576C132.187 97.182 158.79 78 149.455.356z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-2)",
    d: "M60.155 353.203S3.302 311.502.678 248.95c-2.187-27.65 12.245-69.804 47.232-101.987 39.797-36.715 51.167-44.421 59.477-53.94-23.179 28.557-73.472 83.856-81.344 131.45-6.712 45.98 5.683 92.754 34.112 128.73z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-3)",
    d: "M131.958 399.537S92.863 344.245 121.34 284.77c9.653-18.12 43.922-57.615 60.332-93.857 16.41-36.241 19.79-58.08 18.824-83.634 25.581 33.918 66.125 134.745 19.79 212.804 14.48-8.828 36.199-28.343 43.921-49.717-3.86 43.026-24.133 123.873-132.249 129.17z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-4)",
    d: "M135.768 395.973s-25.942-43.76 3.492-87.05c23.448-35.292 48.393-42.35 62.362-80.464 2.494 39.997.998 92.697-35.421 136.928 13.539-2.222 26.347-7.376 37.417-15.057-8.98 17.128-24.945 38.584-67.85 45.643z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-5)",
    d: "M103.589 381.716s-71.061-78.993-21.27-159.879c34.805-58.18 79.279-61.965 88.947-146.634 0 61.019 6.768 91.292-46.89 159.406-35.29 44.652-43.508 105.009-20.787 147.107z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fhir-6)",
    d: "M186.346.356s18.843 55.137-37.685 134.166C107.3 191.955 25.955 277.417 112.355 381.716c-34.928-36.298-68.936-99.245-31.251-174.139C115.802 140.035 199.214 96.11 186.346.357z",
    transform: "translate(68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E02726",
    d: "M293.364 66.183a3.701 3.701 0 01-2.617.874h-2.18v-5.244h3.925c.33.046.637.2.872.437.436.437.436.437.436.874v1.049a1.75 1.75 0 01-.436 2.184m8.285 11.362l-1.309-3.496a19.02 19.02 0 00-1.744-3.059 3.747 3.747 0 00-2.616-1.31 8.41 8.41 0 003.924-2.186 6.126 6.126 0 001.308-3.932 6.346 6.346 0 00-.872-3.06 5.282 5.282 0 00-2.18-2.184 21.255 21.255 0 00-3.052-1.311 12.054 12.054 0 00-3.925-.437h-7.412a2.962 2.962 0 00-2.185.869 2.975 2.975 0 00-.868 2.19V79.03a.96.96 0 00.873.874c1 .247 2.022.393 3.052.437 1.308 0 2.18 0 2.616-.437.436-.437.436-.437.436-.874v-6.992h1.308a3.265 3.265 0 012.18.437 7.129 7.129 0 011.309 2.622l.872 3.933c0 .437 0 .437.436.874l.436.437c.48-.058.96.102 1.308.437h5.668c.437 0 .437 0 .437-.437v-.437a1.97 1.97 0 000-2.185m5.232-1.311a11.144 11.144 0 01-3.488 5.244 11.118 11.118 0 01-5.233 3.495 18.062 18.062 0 01-6.977 1.311 14.537 14.537 0 01-6.54-1.31 15.695 15.695 0 01-5.233-3.496 24.786 24.786 0 01-3.488-5.681 18.169 18.169 0 01-1.308-6.992 17.512 17.512 0 011.308-6.554 11.144 11.144 0 013.488-5.244 11.118 11.118 0 015.233-3.496 18.062 18.062 0 016.977-1.31c2.248-.032 4.477.415 6.54 1.31 1.962.8 3.742 1.989 5.233 3.496a24.786 24.786 0 013.488 5.68 18.169 18.169 0 011.308 6.992l-1.308 6.555m6.105-16.168a27.055 27.055 0 00-4.797-7.429 21.797 21.797 0 00-7.413-4.807 33.943 33.943 0 00-9.593-1.31 22.719 22.719 0 00-9.156 1.747 21.797 21.797 0 00-7.413 4.807 16.871 16.871 0 00-4.797 7.429 20.314 20.314 0 00-1.744 9.176 20.314 20.314 0 001.744 9.177 27.055 27.055 0 004.797 7.428 21.797 21.797 0 007.413 4.807 21.413 21.413 0 009.156 1.748c3.14.057 6.258-.538 9.157-1.748a21.797 21.797 0 007.413-4.807 16.871 16.871 0 004.797-7.428 20.314 20.314 0 001.744-9.177 21.41 21.41 0 00-1.308-9.613"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhir);
export default __webpack_public_path__ + "static/media/Fhir.4a5558f9.svg";
export { ForwardRef as ReactComponent };